var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIconEight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5625 79.4375H79.4375M61.2643 79.4375H20.7357L15.4673 55.6267C15.3515 55.1106 15.3421 54.5764 15.4396 54.0565C15.5372 53.5366 15.7395 53.0421 16.0344 52.603C16.3019 52.1918 16.6659 51.8523 17.0947 51.6141C17.5234 51.3759 18.004 51.2462 18.4944 51.2363H63.5056C63.996 51.2462 64.4766 51.3759 64.9053 51.6141C65.3341 51.8523 65.6981 52.1918 65.9656 52.603C66.2605 53.0421 66.4628 53.5366 66.5604 54.0565C66.6579 54.5764 66.6485 55.1106 66.5328 55.6267L61.2643 79.4375Z",
    stroke: "#FADADF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8538 9.49829C31.0366 11.7618 33.6531 13.5622 36.5472 14.792C39.4412 16.0218 42.5534 16.6559 45.6979 16.6562C48.8857 16.6562 52.0393 16.007 54.9673 14.7497M35.875 64.0625C35.875 65.4217 36.415 66.7252 37.3761 67.6864C38.3372 68.6475 39.6408 69.1875 41 69.1875C42.3592 69.1875 43.6628 68.6475 44.6239 67.6864C45.5851 66.7252 46.125 65.4217 46.125 64.0625C46.125 62.7032 45.5851 61.3997 44.6239 60.4385C43.6628 59.4774 42.3592 58.9375 41 58.9375C39.6408 58.9375 38.3372 59.4774 37.3761 60.4385C36.415 61.3997 35.875 62.7032 35.875 64.0625Z",
    stroke: "#FADADF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0834 43.5625C55.9433 41.1429 53.3137 39.2054 50.3687 37.8785C47.4236 36.5515 44.2302 35.8653 41 35.8653C37.7698 35.8653 34.5764 36.5515 31.6314 37.8785C28.6863 39.2054 26.0567 41.1429 23.9167 43.5625M26.9063 16.6563C26.9063 20.3941 28.3911 23.9789 31.0342 26.622C33.6773 29.2651 37.2621 30.75 41 30.75C44.7379 30.75 48.3227 29.2651 50.9658 26.622C53.6089 23.9789 55.0938 20.3941 55.0938 16.6563C55.0938 12.9184 53.6089 9.33355 50.9658 6.69046C48.3227 4.04737 44.7379 2.5625 41 2.5625C37.2621 2.5625 33.6773 4.04737 31.0342 6.69046C28.3911 9.33355 26.9063 12.9184 26.9063 16.6563Z",
    stroke: "#FADADF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIconEight);
export default __webpack_public_path__ + "static/media/background_icon_eight.c9ebadc4beb9e7a7691626729eb6853a.svg";
export { ForwardRef as ReactComponent };